import { createSelector } from 'reselect';
import { selectInstitutionSummariesByPath } from '../../../ReduxStorage/Institutions/selectors';
import { ReduxState } from '../../../ReduxStorage/state';
import { INITIAL_STATE, PartnersListingPageState } from './store';

const selectState = (state: ReduxState): PartnersListingPageState =>
  state.PartnersListingPage || INITIAL_STATE;

export const selectLocalPartners = createSelector(
  selectState,
  selectInstitutionSummariesByPath,
  (state, institutions) => {
    return state.localPartners.map((path) => institutions[path]);
  }
);

export const selectGlobalPartners = createSelector(
  selectState,
  selectInstitutionSummariesByPath,
  (state, institutions) => {
    return state.globalPartners.map((path) => institutions[path]);
  }
);
